"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Pill;
var _material = require("@mui/material");
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
require("./styles.scss");
function Pill(props) {
  const {
    id,
    label,
    value,
    onClick,
    onRemove,
    className
  } = props;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "pill ".concat(className !== null && className !== void 0 ? className : ''),
    onClick: ev => {
      ev.stopPropagation();
      if (onClick) {
        onClick(id);
      }
    }
  }, label && /*#__PURE__*/_react.default.createElement("p", {
    className: "label"
  }, label, ":"), /*#__PURE__*/_react.default.createElement("p", {
    className: "value".concat(label ? '' : ' value--no-label')
  }, value), onRemove ? /*#__PURE__*/_react.default.createElement(_material.IconButton, {
    onClick: ev => {
      ev.stopPropagation();
      onRemove(id);
    },
    className: "iconContainer",
    "aria-label": "remove"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "close",
    className: "icon"
  })) : /*#__PURE__*/_react.default.createElement("div", {
    className: "spacer"
  }));
}